<template>
  <v-card flat class="border-0">
    <v-toolbar class="mt-3" flat tabs dense>
      <v-icon class="ml-2 mr-4">
        notifications
      </v-icon>
      <v-toolbar-title>
        {{ $tc('notification', 2) }}
      </v-toolbar-title>

      <v-tabs
        v-model="tab"
        slider-color="dinamo"
        slot="extension"
        grow
      >
        <v-tab>{{ $tc('warning', 2) }}</v-tab>
        <v-tab>{{ $tc('error', 2) }}</v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items v-model="tab">
      <!-- WARNING TAB -->
      <v-tab-item>
        <v-card v-for="warning in warnings" :key="warning.title + warning.type" class="no-shadow">
          <template v-if="warning.message">
            <v-expansion-panels flat>
              <v-expansion-panel>
                <v-expansion-panel-header class="px-4 py-3">
                  <v-row>
                    <v-col class="py-0">
                      <v-icon class="" :color="getColor(warning.type)">
                        fiber_manual_record
                      </v-icon>
                      <b class="ml-2 subtitle-1 font-weight-bold">
                        {{ prettyTitle(warning) }}
                      </b>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content @click="cardClicked(warning)">
                  {{ warning.message }}
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
          <template v-else>
            <div class="px-4 py-3">
              <v-icon :color="getColor(warning.type)">
                fiber_manual_record
              </v-icon>
              <b class="ml-2">
                {{ prettyTitle(warning) }}
              </b>
            </div>
          </template>
        </v-card>
      </v-tab-item>
      <!-- ERRORS TAB -->
      <v-tab-item>
        <v-card flat>
          <v-expansion-panels flat>
            <v-expansion-panel v-for="error in errors" :key="error.time">
              <v-expansion-panel-header class="px-4 py-3">
                <v-row no-gutters>
                  <i class="grey--text">
                    {{ error.time | date }}
                  </i>
                  <br>
                  <b class="red--text">
                    {{ getTranslatedErrorAttr(error, 'title') }}
                  </b>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content @click="cardClicked(warning)">
                <!-- <v-card-text v-html="getTranslatedErrorAttr(error, 'message')" /> -->
                {{ getTranslatedErrorAttr(error, 'message') }}
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
const INFO_TYPE = 0
const ATENTION_TYPE = 1
const CAUTION_TYPE = 2
const CRITICAL_TYPE = 3

export default {
  data () {
    return {
      tab: null
    }
  },
  computed: {
    errors () {
      return this.$store.state.error.list
    },
    warnings () {
      const wngArray = this.$store.getters['warning/getWarnings']
      wngArray.sort((a, b) => (a.type > b.type) ? -1 : 1)
      return wngArray
    }
  },
  methods: {
    getTranslatedErrorAttr (error, attr) {
      if (this.$store.state.locale.locale === 'pt-BR') return error.pt[attr]
      else return error.en[attr]
    },
    cardClicked (warning) {
      let pageName
      switch (warning.title) {
        case 'pending_upack': pageName = 'hsm-info'; break
        default: break
      }
      if (this.$route.name !== pageName) this.$router.push({ name: pageName })
    },
    prettyTitle (warning) {
      switch (warning.title) {
        case 'pending_upack': return this.$tc('warnings.pending_upack')
        case 'pending_backup': return this.$tc('warnings.pending_backup')
        case 'current_dt_info': return this.$tc('warnings.wrong_date')
        case 'log_size': return this.$t('warnings.log_size', { num: warning.titleArgs })
        case 'battery_ok': return this.$tc('warnings.battery_low')
        case 'sl_be_len':
          return `${this.$tc('warnings.base_low')} ${warning.titleArgs.usedPercent}%`
        case 'free_blocks':
          return `${this.$tc('warnings.storage_low')} ${warning.titleArgs.usedPercent}%`
      }
    },
    getColor (type) {
      switch (type) {
        case CRITICAL_TYPE: return 'red'
        case CAUTION_TYPE: return 'orange'
        case ATENTION_TYPE: return 'yellow'
        case INFO_TYPE: return 'blue'
        default: return 'green'
      }
    }
  }
}
</script>

<style>
.dot {
  height: 25px;
  width: 25px;
  background-color: #ab12;
  border-radius: 50%;
  display: inline-block;
}
</style>
